<template>
  <section class="products-section section" id="products">
    <div class="container">
      <div class="section-header reveal">
        <span class="label">{{ $store.getters.t('products.subtitle') }}</span>
        <h2>{{ $store.getters.t('products.title') }}</h2>
        <p>{{ $store.getters.t('products.desc') }}</p>
      </div>

      <!-- Product Cards Row - 4 Cards, No Wrap -->
      <div class="products-row">
        <!-- SSMS Card -->
        <div class="product-card reveal" @click="scrollTo('ssms')">
          <div class="product-card-glow glow-blue"></div>
          <div class="product-icon icon-blue">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 2a10 10 0 0 0 0 20"/><path d="M2 12h20"/><path d="M12 2a15 15 0 0 1 0 20"/></svg>
          </div>
          <h3 class="product-name">{{ $store.getters.t('products.ssms.name') }}</h3>
          <p class="product-subtitle">{{ $store.getters.t('products.ssms.subtitle') }}</p>
          <p class="product-desc">{{ $store.getters.t('products.ssms.desc') }}</p>
          <ul class="product-features">
            <li v-for="(f, i) in $store.getters.t('products.ssms.features')" :key="i">
              <span class="check-icon">&#10003;</span> {{ f }}
            </li>
          </ul>
          <span class="learn-more">{{ $store.getters.isZh ? '了解详情' : 'Learn More' }} <span class="arrow">&rarr;</span></span>
        </div>

        <!-- EOM Card -->
        <div class="product-card reveal reveal-delay-1" @click="scrollTo('eom')">
          <div class="product-card-glow glow-purple"></div>
          <div class="product-icon icon-purple">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8"/><path d="M12 17v4"/></svg>
          </div>
          <h3 class="product-name">{{ $store.getters.t('products.eom.name') }}</h3>
          <p class="product-subtitle">{{ $store.getters.t('products.eom.subtitle') }}</p>
          <p class="product-desc">{{ $store.getters.t('products.eom.desc') }}</p>
          <ul class="product-features">
            <li v-for="(f, i) in $store.getters.t('products.eom.features')" :key="i">
              <span class="check-icon">&#10003;</span> {{ f }}
            </li>
          </ul>
          <span class="learn-more">{{ $store.getters.isZh ? '了解详情' : 'Learn More' }} <span class="arrow">&rarr;</span></span>
        </div>

        <!-- RPA Card -->
        <div class="product-card reveal reveal-delay-2" @click="scrollTo('rpa')">
          <div class="product-card-glow glow-green"></div>
          <div class="product-icon icon-green">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="4"/><circle cx="8.5" cy="8.5" r="1.5"/><circle cx="15.5" cy="8.5" r="1.5"/><path d="M8 14s1.5 2 4 2 4-2 4-2"/></svg>
          </div>
          <h3 class="product-name">{{ $store.getters.t('products.rpa.name') }}</h3>
          <p class="product-subtitle">{{ $store.getters.t('products.rpa.subtitle') }}</p>
          <p class="product-desc">{{ $store.getters.t('products.rpa.desc') }}</p>
          <ul class="product-features">
            <li v-for="(f, i) in $store.getters.t('products.rpa.features')" :key="i">
              <span class="check-icon">&#10003;</span> {{ f }}
            </li>
          </ul>
          <span class="learn-more">{{ $store.getters.isZh ? '了解详情' : 'Learn More' }} <span class="arrow">&rarr;</span></span>
        </div>

        <!-- DAuto Card - 4th card in same row -->
        <div class="product-card product-card-dauto reveal reveal-delay-3" @click="scrollTo('dauto')">
          <div class="product-card-glow glow-cyan"></div>
          <div class="product-icon icon-cyan">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="2" width="20" height="20" rx="5"/><path d="M16 2v4H8V2"/><path d="M8 12h8"/><path d="M8 16h5"/></svg>
          </div>
          <span class="dauto-badge">{{ $store.getters.isZh ? '全新产品线' : 'New Product Line' }}</span>
          <h3 class="product-name">{{ $store.getters.t('products.dauto.name') }}</h3>
          <p class="product-subtitle">{{ $store.getters.isZh ? '工业科技·数自一体化' : 'Industrial Tech · IT-OT Convergence' }}</p>
          <p class="product-desc">{{ $store.getters.t('products.dauto.desc') }}</p>
          <ul class="product-features">
            <li v-for="(item, idx) in $store.getters.t('products.dauto.detailItems')" :key="idx">
              <span class="check-icon">&#10003;</span>
              <span>{{ item.title }}</span>
            </li>
          </ul>
          <span class="learn-more dauto-learn-more">{{ $store.getters.isZh ? '探索详情' : 'Explore' }} <span class="arrow">&rarr;</span></span>
        </div>
      </div>

      <!-- Product Detail Sections -->
      <ProductDetail id="ssms" product-key="ssms" class-name="product-detail-blue" color-accent="#3b82f6" />
      <ProductDetail id="eom" product-key="eom" class-name="product-detail-purple" color-accent="#8b5cf6" />
      <ProductDetail id="rpa" product-key="rpa" class-name="product-detail-green" color-accent="#10b981" />
      <ProductDetail id="dauto" product-key="dauto" class-name="product-detail-cyan" color-accent="#06b6d4" />
    </div>
  </section>
</template>

<script>
import ProductDetail from './ProductDetail.vue'

export default {
  name: 'ProductsSection',
  components: { ProductDetail },
  methods: {
    scrollTo(key) {
      this.$nextTick(() => {
        const el = document.getElementById(key)
        if (el) el.scrollIntoView({ behavior: 'smooth' })
      })
    },
    goDAuto() {
      this.$router.push('/digital-automation')
    }
  }
}
</script>

<style scoped>
/* Product Row - Flex No Wrap */
.products-row {
  display: flex;
  flex-wrap: nowrap;
  gap: 24px;
  margin-bottom: 60px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: x proximity;
  padding-bottom: 4px;
}
.products-row::-webkit-scrollbar {
  height: 6px;
}
.products-row::-webkit-scrollbar-track {
  background: rgba(255,255,255,.03);
  border-radius: 3px;
}
.products-row::-webkit-scrollbar-thumb {
  background: rgba(255,255,255,.12);
  border-radius: 3px;
}
.products-row::-webkit-scrollbar-thumb:hover {
  background: rgba(255,255,255,.2);
}
.product-card {
  flex: 1 1 0;
  min-width: 260px;
  max-width: 340px;
  background: linear-gradient(180deg, rgba(30,41,59,.9) 0%, rgba(20,30,50,.95) 100%);
  border: 1px solid rgba(255,255,255,.05);
  border-radius: 20px;
  padding: 40px 32px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all .45s cubic-bezier(.4,0,.2,1);
  display: flex;
  flex-direction: column;
  scroll-snap-align: start;
}
.product-card:hover {
  transform: translateY(-10px);
  border-color: rgba(255,255,255,.1);
  box-shadow: 0 24px 48px rgba(0,0,0,.35);
}
.product-card-glow {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  opacity: 0;
  transition: opacity .5s;
  pointer-events: none;
}
.product-card:hover .product-card-glow { opacity: 1; }
.glow-blue { background: radial-gradient(ellipse at 30% 20%, rgba(59,130,246,.08) 0%, transparent 50%); }
.glow-purple { background: radial-gradient(ellipse at 30% 20%, rgba(139,92,246,.08) 0%, transparent 50%); }
.glow-green { background: radial-gradient(ellipse at 30% 20%, rgba(16,185,129,.08) 0%, transparent 50%); }
.glow-cyan { background: radial-gradient(ellipse at 30% 20%, rgba(6,182,212,.08) 0%, transparent 50%); }

.product-icon {
  width: 56px; height: 56px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  transition: transform .4s;
  position: relative;
  z-index: 1;
}
.product-card:hover .product-icon { transform: scale(1.05); }
.icon-blue { background: linear-gradient(135deg, rgba(59,130,246,.18), rgba(59,130,246,.05)); color: #3b82f6; box-shadow: inset 0 1px 0 rgba(255,255,255,.1); }
.icon-purple { background: linear-gradient(135deg, rgba(139,92,246,.18), rgba(139,92,246,.05)); color: #8b5cf6; box-shadow: inset 0 1px 0 rgba(255,255,255,.1); }
.icon-green { background: linear-gradient(135deg, rgba(16,185,129,.18), rgba(16,185,129,.05)); color: #10b981; box-shadow: inset 0 1px 0 rgba(255,255,255,.1); }
.icon-cyan { background: linear-gradient(135deg, rgba(6,182,212,.18), rgba(6,182,212,.05)); color: #06b6d4; box-shadow: inset 0 1px 0 rgba(255,255,255,.1); }

.product-name {
  font-size: 19px; font-weight: 700;
  color: #f1f5f9; margin-bottom: 4px;
  position: relative; z-index: 1;
}
.product-subtitle {
  font-size: 12px; color: #60a5fa;
  letter-spacing: 1px; text-transform: uppercase; margin-bottom: 14px;
  position: relative; z-index: 1;
  font-weight: 500;
}
.product-card-dauto .product-subtitle {
  color: #06b6d4;
}
.product-desc {
  font-size: 14px; color: #94a3b8;
  line-height: 1.7; margin-bottom: 18px;
  position: relative; z-index: 1;
}
.product-features {
  list-style: none;
  margin-bottom: 24px;
  flex: 1;
  position: relative; z-index: 1;
}
.product-features li {
  font-size: 12.5px; color: #94a3b8;
  padding: 4px 0; display: flex; align-items: flex-start; gap: 8px;
}
.check-icon { color: #3b82f6; font-weight: 700; flex-shrink: 0; margin-top: 1px; }
.product-card:nth-child(3) .check-icon { color: #10b981; }
.product-card-dauto .check-icon { color: #06b6d4; }

.learn-more {
  font-size: 13px; font-weight: 600;
  color: #60a5fa;
  display: inline-flex; align-items: center; gap: 6px;
  position: relative; z-index: 1;
  transition: gap .3s;
}
.learn-more .arrow { transition: transform .3s; }
.product-card:hover .learn-more { gap: 10px; }
.product-card:hover .learn-more .arrow { transform: translateX(3px); }
.product-card:nth-child(3) .learn-more { color: #10b981; }
.dauto-learn-more { color: #06b6d4; }

/* DAuto Card Specific */
.product-card-dauto {
  border-color: rgba(6,182,212,.1);
}
.product-card-dauto:hover {
  border-color: rgba(6,182,212,.25);
}
.dauto-badge {
  padding: 3px 10px;
  background: rgba(6,182,212,.15);
  border: 1px solid rgba(6,182,212,.25);
  border-radius: 12px;
  font-size: 11px;
  color: #06b6d4;
  font-weight: 600;
  letter-spacing: .5px;
  display: inline-block;
  margin-bottom: 10px;
  position: relative;
  z-index: 1;
  align-self: flex-start;
}

@media (max-width: 1200px) {
  .product-card {
    min-width: 245px;
    padding: 32px 24px;
  }
}
@media (max-width: 768px) {
  .products-row {
    gap: 16px;
  }
  .product-card {
    min-width: 270px;
    padding: 28px 20px;
  }
}
</style>
